import DetailIcons from '@components/elements/detail/detailIcons';
import DetailTopContainer from '@components/atoms/container/detailTopContainer';
import DetailAccessibility from '@components/elements/detail/detailAccessibility';

export default function DetailTop() {
  return (
    <DetailTopContainer id='detailTop'>
      <DetailIcons />
      <DetailAccessibility />
    </DetailTopContainer>
  );
}
